module.exports = {"640502100":"滨河镇","640502101":"文昌镇","640502102":"东园镇","640502103":"柔远镇","640502104":"镇罗镇","640502105":"宣和镇","640502106":"永康镇","640502107":"常乐镇","640502108":"迎水桥镇","640502109":"兴仁镇","640502200":"香山乡","640502400":"中卫山羊选育场","640502401":"中卫工业园区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640502.json
// module id = 3045
// module chunks = 0